export const CANTICLES: { [id: string]: { lines: [string, string][] } } = {
    "benedictus es": {
        lines: [
            [
                "BLESS_ED art thou, O Lord /God of our /fa_thers;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
            [
                "Bless_ed art thou for the /name of thy /Ma_jes_ty;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
            [
                "Bless_ed art thou in the tem_ple /of thy /ho_li_ness;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
            [
                "Bless_ed art thou that be_hold_est the depths, and dwell_est be_/tween the /Che_ru_bim;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
            [
                "Bless_ed art thou on the glo_rious /throne of thy /king_dom;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
            [
                "Bless_ed art thou in the fir_ma_/ment of /heav_en;",
                "praised and ex_al_ted a_bove /all for /ev_er.",
            ],
        ],
    },
    "pascha nostrum": {
        lines: [
            [
                "Christ our Pass_o_ver is sa_cri_ficed for /us;",
                "there_fore /let us /keep the /feast,",
            ],
            [
                "Not with old lea_ven, nei_ther with the lea_ven of /mal_ice and /wick_ed_ness,",
                "but with the un_leav_ened bread of sin_/ce_ri_/ty and /truth.",
            ],
            [
                "Christ be_ing raised from the dead di_eth no /more;",
                "death hath no more do_/min_ion /o_ver him.",
            ],
            [
                "For in that he died, he died un_to sin /once;",
                "but in that he liv_eth, he /liv_eth /un_to God.",
            ],
            [
                "Like_wise re_ckon ye also your_selves to be dead in_deed un_to /sin,",
                "but a_live un_to God through Je_sus /Christ our Lord.",
            ],
            [
                "Christ is ris_en from the /dead,",
                "and be_come the /first-_fruits of /them that /slept.",
            ],
            [
                "For since by man came /death,",
                "by man came al_so the re_sur_/rec_tion /of the /dead.",
            ],
            [
                "For as in A_dam all /die,",
                "e_ven so in Christ shall all be /made a_live.",
            ],
        ],
    },
    venite: {
        lines: [
            [
                "O COME, let us /sing un_to /the /LORD;",
                "let us hear_ti_ly re_joice in the strength of /our sal_/va_tion.",
            ],
            [
                "Let us come be_fore his pres_ence /with thanks_/giv_ing",
                "and show our_selves /glad in /him with /Psalms.",
            ],
            [
                "For the /LORD is a /great /God",
                "and a great /King a_/bove /all gods.",
            ],
            [
                "In his hand are all the /cor_ners of /the /earth",
                "and the strength of the hills /is his /al_so.",
            ],
            [
                "The sea is /his, and /he /made it",
                "and his hands pre_/pared the /dry land.",
            ],
            [
                "O come, let us /wor_ship and /fall /down",
                "and kneel be_fore the /Lord our /Ma_ker.",
            ],
            [
                "For /he is the /LORD our /God",
                "and we are the peo_ple of his pas_ture, and the /sheep of his /hand.",
            ],
            [
                "To_day if ye will hear his voice, /hard_en /not your /hearts",
                "as in the pro_vo_ca_tion, and as in the day of temp_ta_tion /in the /wil_der_ness;",
            ],
            [
                "When your /fa_thers /temp_ted me",
                "proved /me, and /saw my works.",
            ],
            [
                "For_ty years long was I grieved with this gen_er_/a_tion, and /said,",
                "It is a peo_ple that do err in their heart, for they /have not /known my ways.",
            ],
            [
                "Un_to whom I /sware in my /wrath",
                "that they should not en_ter /in_to /my /rest.",
            ],
        ],
    },
    "te deum": {
        lines: [
            [
                "WE praise thee, O God we ack_now_ledge /thee to /be the /Lord.",
                "All the earth doth wor_ship thee the Fa_ther /e_ver_/last_ing.",
            ],
            [
                "To thee all An_gels cry a_loud; the Hea_vens, and all the /Pow_ers /there_/in.",
                "To thee Che_ru_bim and Se_ra_phim con_/ti_nu_al_/ly do /cry,",
            ],
            [
                "Ho_ly, Ho_ly, Ho_ly Lord /God of /Sa_ba_oth;",
                "Heav_en and earth are full of the Ma_je_sty /of thy /glo_ry.",
            ],
            [
                "The glo_ri_ous com_pa_ny of the A_/po_stles /praise thee.",
                "The good_ly fel_low_ship of the /Pro_phets /praise thee.",
            ],
            [
                "The no_ble ar_my of /Mar_tyrs /praise thee.",
                "The ho_ly Church through_out all the world /doth ack_/now_ledge thee;",
            ],
            [
                "The Fa_ther of an in_fi_nite Ma_jes_ty; Thine hon_our_a_ble, /true and /on_ly /Son;",
                "Al_so the Ho_ly /Ghost, the /Com_for_ter.",
            ],
            [
                "Thou art the King of /Glo_ry O /Christ.",
                "Thou art the e_ver_last_ing /Son of the /Fa_ther.",
            ],
            [
                "When thou took_est up_on thee /to de_/li_ver /man",
                "thou didst hum_ble thy_self to be /born of a /Vir_gin.",
            ],
            [
                "When thou hadst o_ver_come the /sharp_ness of /death",
                "thou didst o_pen the King_dom of Hea_ven to /all be_/lie_vers.",
            ],
            [
                "Thou sitt_est at the /right hand of /God",
                "in the glo_ry /of the /Fa_ther.",
            ],
            [
                "We be_lieve that thou shalt /come to /be our /Judge.",
                "We there_fore pray thee, help thy ser_vants whom thou hast re_deemed /with thy /prec_ious /blood.",
            ],
            [
                "Make them to be /num_bered /with thy /Saints",
                "in glo_ry /ev_er_/last_ing.",
            ],
            [
                "O Lord, save thy peo_ple and /bless thine /he_ri_tage.",
                "Gov_ern them and lift them /up for /e_ver.",
            ],
            [
                "Day by day we /mag_ni_fy /thee;",
                "And we wor_ship thy Name e_ver /world with_/out end.",
            ],
            [
                "Vouch_safe, O Lord, to keep us this /day with_/out /sin.",
                "O Lord, have mer_cy up_on us; have /mer_cy up_/on us.",
            ],
            [
                "O Lord, let thy mer_cy be up_on us as our /trust is in /thee.",
                "O Lord, in thee have I trust_ed; let me ne_ver /be con_/found_ed.",
            ],
        ],
    },
    benedictus: {
        lines: [
            [
                "BLESS_ED be the Lord /God of /Is_ra_el",
                "for he hath vi_si_ted and re_/deemed his /peo_ple;",
            ],
            [
                "And hath raised up a migh_ty sal_/va_tion /for us",
                "in the house of his /ser_vant /Da_vid;",
            ],
            [
                "As he spake by the mouth of his /ho_ly /Pro_phets",
                "which have been /since the /world be_/gan;",
            ],
            [
                "That we should be saved /from our /e_ne_mies",
                "and from the hand of /all that /hate us.",
            ],
            [
                "To per_form the mer_cy prom_ised /to our /fore_fath_ers",
                "and to re_mem_ber his /ho_ly /co_ve_nant;",
            ],
            [
                "To per_form the oath which he sware to our /fore_fa_ther /A_bra_ham",
                "that /he would /give us;",
            ],
            [
                "That we be_ing de_liv_ered out of the /hand of our /e_ne_mies",
                "might /serve him with_/out fear;",
            ],
            [
                "In ho_li_ness and right_eous_/ness be_/fore him",
                "all the /days of our /life.",
            ],
            [
                "And thou, child, shalt be called the /Pro_phet of the /High_est",
                "for thou shalt go be_fore the face of the Lord /to pre_/pare his /ways;",
            ],
            [
                "To give know_ledge of sal_va_tion /un_to his /peo_ple",
                "for the re_/miss_ion /of their /sins,",
            ],
            [
                "Through the ten_der /mer_cy of /our /God",
                "where_by the day-_spring from on high hath /vi_si_ted /us;",
            ],
            [
                "To give light to them that sit in dark_ness, and in the /sha_dow of /death",
                "and to guide our feet in_/to the /way of /peace.",
            ],
        ],
    },
    magnificat: {
        lines: [
            [
                "MY soul doth /mag_ni_fy /the /Lord",
                "and my spi_rit hath re_joiced in /God my /Sav_iour.",
            ],
            [
                "For he /hath re_/gar_ded",
                "the low_li_ness of /his hand_/maid_en.",
            ],
            [
                "For be_/hold, from /hence_forth",
                "all ge_ne_ra_tions shall /call me /bless_ed.",
            ],
            [
                "For he that is migh_ty hath /mag_ni_fied /me",
                "and /ho_ly /is his /Name.",
            ],
            [
                "And his mer_cy is on /them that /fear him",
                "through_out all /ge_ne_/ra_tions.",
            ],
            [
                "He hath showed /strength with his /arm",
                "he hath scatt_ered the proud in the i_ma_gi_/na_tion of /their hearts.",
            ],
            [
                "He hath put down the /migh_ty /from their /seat",
                "and hath ex_al_ted the /hum_ble and /meek.",
            ],
            [
                "He hath filled the /hun_gry with /good things",
                "and the rich he hath sent /emp_ty a_/way.",
            ],
            [
                "He re_mem_ber_ing his mer_cy hath hol_pen his /ser_vant /Is_ra_el",
                "as he pro_mised to our fore_fa_thers, A_bra_ham and his /seed, for /e_ver.",
            ],
        ],
    },
    "nunc dimittis": {
        lines: [
            [
                "LORD, now let_test thou thy /ser_vant de_/part in /peace",
                "ac_/cor_ding /to thy word.",
            ],
            [
                "For mine eyes have seen /thy sal_/va_tion,",
                "Which thou hast pre_pared be_fore the /face of all /peo_ple;",
            ],
            [
                "To be a light to /ligh_ten the /Gen_tiles",
                "and to be the glo_ry of thy /peo_ple /Is_ra_el.",
            ],
        ],
    },
    "quicunque vult": {
        lines: [
            [
                "Who_so_e_ver will be /saved",
                "be_fore all things it is ne_ces_sa_ry that he hold the /Cath_olic Faith.",
            ],
            [
                "Which Faith ex_cept e_very one do keep whole and un_de_/filed",
                "with_out doubt he shall pe_rish e_ver_/last_ing_ly.",
            ],
            [
                "And the Cath_olic Faith is /this:",
                "That we wor_ship one God in Tri_ni_ty, and Tri_ni_ty in /U_ni_ty;",
            ],
            [
                "Nei_ther con_found_ing the /Per_sons",
                "nor di_vi_ding the /Sub_stance.",
            ],
            [
                "For there is one Per_son of the Fa_ther, a_no_ther of the /Son",
                "and a_no_ther of the /Ho_ly Ghost.",
            ],
            [
                "But the God_head of the Fa_ther, of the Son, and of the Ho_ly Ghost, is all /one",
                "the Glo_ry e_qual, the Ma_je_sty co-_e_/ter_nal.",
            ],
            [
                "Such as the Fa_ther is, such is the /Son",
                "and such is the /Ho_ly Ghost.",
            ],
            [
                "The Fa_ther un_cre_ate, the Son un_cre_/ate",
                "and the Ho_ly Ghost /un_cre_ate.",
            ],
            [
                "The Fa_ther in_com_pre_hen_si_ble, the Son in_com_pre_/hen_si_ble",
                "and the Ho_ly Ghost in_com_pre_/hen_si_ble.",
            ],
            [
                "The Fa_ther e_ter_nal, the Son e_/ter_nal",
                "and the Ho_ly Ghost e_/ter_nal.",
            ],
            ["And yet they are not three e_/ter_nals", "but one e_/ter_nal."],
            [
                "As al_so there are not three in_com_pre_hen_si_bles, nor three un_cre_/a_ted",
                "but one un_cre_a_ted, and one in_com_pre_/hen_si_ble.",
            ],
            [
                "So like_wise the Fa_ther is Al_migh_ty, the Son Al_/migh_ty",
                "and the Ho_ly Ghost Al_/migh_ty.",
            ],
            [
                "And yet they are not three Al_/migh_ties",
                "but one Al_/migh_ty.",
            ],
            [
                "So the Fa_ther is God, the Son is God, and the Ho_ly /Ghost is God.",
                "And yet they are not three Gods, but /one God.",
            ],
            [
                "So like_wise the Fa_ther is Lord, the Son Lord, and the Ho_ly /Ghost Lord.",
                "And yet not three Lords, but /one Lord.",
            ],
            [
                "For like as we are com_pelled by the Chris_tian /ve_ri_ty",
                "to ack_now_ledge e_very Per_son by him_self to be /God and Lord;",
            ],
            [
                "So are we for_bid_den by the Cath_olic Re_/li_gion",
                "to say there be three Gods, or /three Lords.",
            ],
            [
                "The Fa_ther is made of /none",
                "neither cre_a_ted, nor be_/got_ten.",
            ],
            [
                "The Son is of the Fa_ther a_/lone",
                "not made, nor cre_a_ted, but be_/got_ten.",
            ],
            [
                "The Ho_ly Ghost is of the Fa_ther and of the /Son",
                "nei_ther made, nor cre_a_ted, nor be_got_ten, but pro_/ceed_ing.",
            ],
            [
                "So there is one Fa_ther, not three Fa_thers; one Son, not /three Sons",
                "one Ho_ly Ghost, not three /Ho_ly Ghosts.",
            ],
            [
                "And in this Tri_ni_ty none is a_fore, or af_ter o_ther; none is grea_ter, or less than a_/no_ther;",
                "But the whole three Per_sons are co-_e_ter_nal to_/ge_ther and co-_/e_qual.",
            ],
            [
                "So that in all things, as is a_/fore_said",
                "the U_ni_ty in Tri_ni_ty, and the Tri_ni_ty in U_ni_ty is to be /wor_shipped.",
            ],
            [
                "He there_fore that will be /saved",
                "must thus think of the /Tri_ni_ty.",
            ],
            [
                "Fur_ther_more it is ne_ces_sa_ry to e_ver_last_ing sal_/va_tion",
                "that he al_so be_lieve right_ly the In_car_na_tion of our Lord /Je_sus Christ.",
            ],
            [
                "For the right Faith is that we be_lieve and con_/fess",
                "that our Lord Je_sus Christ, the Son of God, is /God and Man;",
            ],
            [
                "God, of the Sub_stance of the Fa_ther, be_got_ten be_/fore the worlds",
                "and Man, of the Sub_stance of his Mo_ther, born /in the world;",
            ],
            [
                "Per_fect God, and Per_fect /Man",
                "of a rea_so_na_ble soul and hu_man flesh sub_/sist_ing;",
            ],
            [
                "E_qual to the Fa_ther, as touch_ing his /God_head",
                "and in_fe_ri_or to the Fa_ther, as touch_ing his /Man_hood.",
            ],
            [
                "Who al_though he be God and /Man",
                "yet he is not two, but /one Christ;",
            ],
            [
                "One, not by con_ver_sion of the God_head in_to /flesh",
                "but by taking of the Man_hood /in_to God;",
            ],
            [
                "One al_to_ge_ther, not by con_fu_sion of /Sub_stance",
                "but by u_ni_ty of /Per_son.",
            ],
            [
                "For as the rea_so_na_ble soul and flesh is /one man",
                "so God and Man is /one Christ.",
            ],
            [
                "Who suf_fered for our sal_/va_tion",
                "de_scend_ed into hell, rose again the third day /from the dead.",
            ],
            [
                "He a_scend_ed in_to hea_ven, he sit_teth on the right hand of the Fa_ther, God Al_/migh_ty:",
                "from whence he shall come to judge the /quick and the dead.",
            ],
            [
                "At whose com_ing all men shall rise a_gain with their /bo_dies",
                "and shall give ac_count for their /own works.",
            ],
            [
                "And they that have done good shall go into life e_ver_/last_ing",
                "and they that have done e_vil in_to e_ver_/last_ing fire.",
            ],
            [
                "This is the Ca_tholic /Faith",
                "which ex_cept a man be_lieve faith_ful_ly, he can_/not be saved.",
            ],
        ],
    },
};
